module.exports = __webpack_public_path__ + "static/media/SopravalCajasLucas.906b6cf3.mp3";